import { useState, useEffect } from "react";
import {
  BsFillArrowRightCircleFill,
  BsFillArrowLeftCircleFill,
} from "react-icons/bs";
import { collection, onSnapshot } from "firebase/firestore";
import { db } from "../../firebase"; // Adjust the path according to your project structure
import blackboardImage from "../../media/blackboard.png";

function Carousel() {
  const [slides, setSlides] = useState([]);
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const slidesCollectionRef = collection(db, "slides");
    const unsubscribe = onSnapshot(slidesCollectionRef, (snapshot) => {
      const slidesData = snapshot.docs.map((doc) => ({
        id: doc.id,
        text: doc.data().text,
        imageUrl: doc.data().imageUrl, // Add this line to fetch the imageUrl
      }));
      setSlides(slidesData);
      setCurrent((c) => (slidesData.length ? Math.min(c, slidesData.length - 1) : 0));
    });

    return unsubscribe;
  }, []);

  const nextSlide = () => {
    setCurrent((current + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrent((current - 1 + slides.length) % slides.length);
  };

  return slides.length > 0 ? (
    <div className="flex justify-center items-center pt-8 pb-16">
      <div className="relative w-full max-w-4xl">
        {" "}
        {/* This will control the width of the blackboard */}
        {/* Left Arrow */}
        <button
          aria-label="Previous slide"
          className="absolute left-0 top-1/2 transform -translate-y-1/2 -translate-x-12 text-white hover:text-stone-300 z-10"
          onClick={prevSlide}
        >
          <BsFillArrowLeftCircleFill size="2em" />
        </button>
        <div
          className="bg-center bg-no-repeat"
          style={{
            backgroundImage: `url(${blackboardImage})`,
            backgroundSize: "80%", // Increase the size of the background image
            height: "400px", // Adjust the height as needed
          }}
        >
          {/* Text slides */}
          {slides.map((slide, index) => (
            <div
              key={slide.id}
              className={`absolute m-auto w-[250px] h-[150px] inset-0 flex items-center justify-center transition-opacity duration-500 ease-in-out ${
                current === index ? "opacity-100" : "opacity-0"
              }`}
              style={{ zIndex: 1 }}
            >
              {slide.imageUrl ? (
                <img
                  src={slide.imageUrl}
                  alt={`Slide ${index + 1}`}
                  style={{
                    maxWidth: "100%",
                    maxHeight: "100%",
                    objectFit: "contain",
                  }}
                />
              ) : (
                <p className="text-white text-2xl md:text-3xl lg:text-4xl text-center font-chalk">
                  {slide.text}
                </p>
              )}
            </div>
          ))}
        </div>
        {/* Right Arrow */}
        <button
          aria-label="Next slide"
          className="absolute right-0 top-1/2 transform -translate-y-1/2 translate-x-12 text-white hover:text-stone-300 z-10"
          onClick={nextSlide}
        >
          <BsFillArrowRightCircleFill size="2em" />
        </button>
      </div>
    </div>
  ) : null;
}

export default Carousel;
